(function () {

const overlay = document.getElementById('site-footer');
const closeBtn = overlay?.querySelector('.footer-close');

// Triggers: any menu item given the WP Admin CSS class "js-contact-trigger"
const triggers = document.querySelectorAll('.js-contact-trigger > a, a.js-contact-trigger');

if (!overlay || !triggers.length) return;

const isReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
let previousFocus = null;

function getFocusable() {
    return Array.from(
        overlay.querySelectorAll(
            'button:not([disabled]):not([tabindex="-1"]), [href]:not([tabindex="-1"]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
    );
}

function openOverlay(triggerEl) {
    previousFocus = triggerEl;
    window.returnFocusTo = triggerEl; // integrate with theme.js Escape handler

    triggerEl.setAttribute('aria-expanded', 'true');

    // Capture position BEFORE any state changes affect layout
    const startY = isReduced ? 0 : Math.min(Math.max(0, overlay.getBoundingClientRect().top), window.innerHeight);

    // Snap footer to fixed at its current visual location — no transition yet
    overlay.classList.add('is-open', 'is-no-transition');
    overlay.style.transform = `translateY(${startY}px)`;

    document.body.classList.add('contact-open');
    document.dispatchEvent(new CustomEvent('contact:open'));

    // Restart the footer graphics drop animation as the footer slides up
    if (!isReduced) {
        const graphic1 = overlay.querySelector('.footer-graphic-1');
        const graphic2 = overlay.querySelector('.footer-graphic-2');
        if (graphic1 && graphic2) {
            graphic1.classList.remove('is-floating');
            graphic2.classList.remove('is-floating');
            void graphic1.offsetWidth; // force reflow to restart CSS animation
            graphic1.classList.add('is-floating');
            graphic2.classList.add('is-floating');
        }
    }

    // Double rAF ensures the browser paints the start frame before the transition fires
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            overlay.classList.remove('is-no-transition');
            overlay.style.transform = '';
        });
    });

    // Fade close button in after the animation settles, then focus first form field
    setTimeout(() => {
        overlay.classList.add('is-close-visible');
        const firstField = overlay.querySelector('.footer-form input, .footer-form textarea, .footer-form select');
        (firstField ?? closeBtn)?.focus();
    }, isReduced ? 0 : 450);

    addScrollClose();
}

function closeOverlay() {
    removeScrollClose();
    overlay.classList.remove('is-close-visible');
    document.body.classList.remove('contact-open');

    if (isReduced) {
        overlay.classList.remove('is-open');
        overlay.style.transform = '';
        document.dispatchEvent(new CustomEvent('contact:close'));
    } else {
        // Slide footer back down off screen, then restore it to the natural flow
        overlay.style.transform = `translateY(${window.innerHeight}px)`;
        setTimeout(() => {
            overlay.classList.remove('is-open');
            overlay.style.transform = '';
            document.dispatchEvent(new CustomEvent('contact:close'));
        }, 650);
    }

    if (previousFocus) {
        previousFocus.setAttribute('aria-expanded', 'false');
        previousFocus.focus();
        previousFocus = null;
        window.returnFocusTo = undefined;
    }
}

triggers.forEach(trigger => {
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', 'site-footer');
    trigger.addEventListener('click', e => {
        e.preventDefault();
        openOverlay(trigger);
    });
});

closeBtn?.addEventListener('click', closeOverlay);

// Close on scroll intent (wheel + touch) — scroll events won't fire because
// body.contact-open sets overflow: hidden, but wheel/touchmove still do.
let scrollCloseHandler = null;

function addScrollClose() {
    scrollCloseHandler = (e) => {
        // Only block close if the user is scrolling within the form or footer-body scroll area
        const footerBody = overlay.querySelector('.footer-body');
        if (footerBody?.contains(e.target) && footerBody.scrollHeight > footerBody.clientHeight) return;
        closeOverlay();
    };
    window.addEventListener('wheel', scrollCloseHandler, { passive: true });
    window.addEventListener('touchmove', scrollCloseHandler, { passive: true });
}

function removeScrollClose() {
    if (scrollCloseHandler) {
        window.removeEventListener('wheel', scrollCloseHandler);
        window.removeEventListener('touchmove', scrollCloseHandler);
        scrollCloseHandler = null;
    }
}

// Global Escape handler
document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        closeOverlay();
    }
});

// Focus trap
overlay.addEventListener('keydown', e => {
    if (e.key !== 'Tab' || !overlay.classList.contains('is-open')) return;

    const focusable = getFocusable();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
        last.focus();
        e.preventDefault();
    } else if (!e.shiftKey && document.activeElement === last) {
        first.focus();
        e.preventDefault();
    }
});

})();
